import { create } from 'zustand';

interface BreadcrumbItems {
  title: JSX.Element;
}

type State = {
  title: string;
  breadcrumbItems: BreadcrumbItems[];
};

type Action = {
  setTitle: (title: State['title']) => void;
  setBreadcrumb: (breadcrumbItems: State['breadcrumbItems']) => void;
};

const pageTitleStore = create<State & Action>((set) => ({
  title: '',
  breadcrumbItems: [],
  setTitle: (title: string) => set(() => ({ title: title })),
  setBreadcrumb: (breadcrumbItems: BreadcrumbItems[]) =>
    set(() => ({ breadcrumbItems: breadcrumbItems })),
}));

export default pageTitleStore;
